const SUPERADMIN_BASE = process.env.REACT_APP_SUPERADMIN_API_URL || 'http://localhost:3010/api/v1';

async function request(path, options = {}) {
  const res = await fetch(`${SUPERADMIN_BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    credentials: 'include',
    ...options,
  });
  if (!res.ok) {
    let body;
    try { body = await res.json(); } catch (_) { body = { error: res.statusText }; }
    throw new Error(body?.error || `Request failed (${res.status})`);
  }
  try { return await res.json(); } catch (_) { return null; }
}

export const superadminApi = {
  registerCompany: (payload) => request('/companies', { method: 'POST', body: JSON.stringify(payload) }),
  approveCompany: (slug) => request(`/companies/${encodeURIComponent(slug)}/approve`, { method: 'POST' }),
  listCompanies: () => request('/companies', { method: 'GET' }),
  listAdmins: () => request('/admins', { method: 'GET' }),
  // Analytics
  getAnalytics: () => request('/analytics', { method: 'GET' }),
  // Subscriptions
  listPlans: () => request('/subscriptions', { method: 'GET' }),
  createPlan: (payload) => request('/subscriptions', { method: 'POST', body: JSON.stringify(payload) }),
  updatePlan: (id, payload) => request(`/subscriptions/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(payload) }),
  deletePlan: (id) => request(`/subscriptions/${encodeURIComponent(id)}`, { method: 'DELETE' }),
  // Discounts
  listDiscounts: () => request('/discounts', { method: 'GET' }),
  createDiscount: (payload) => request('/discounts', { method: 'POST', body: JSON.stringify(payload) }),
  updateDiscount: (id, payload) => request(`/discounts/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(payload) }),
  deleteDiscount: (id) => request(`/discounts/${encodeURIComponent(id)}`, { method: 'DELETE' }),
};

export default superadminApi;
